import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexInternationalization',
  setup(__props) {

const LanguageInternationa = defineAsyncComponent(() => import("@/components/theme/internationalization/LanguageInternationa.vue"))
const LanguagePicker = defineAsyncComponent(() => import("@/components/theme/internationalization/LanguagePicker.vue"))
const LanguageView = defineAsyncComponent(() => import("@/components/theme/internationalization/LanguageView.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Pages",
      mains: "Internationalization",
      title: "Internationalization"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(LanguageInternationa)),
        _createVNode(_unref(LanguagePicker)),
        _createVNode(_unref(LanguageView))
      ])
    ])
  ], 64))
}
}

})